<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <section class="section01">
            <div class="object01">
              사용자 관리
            </div>
          </section>
          <section class="section02">
            <div class="object01"></div>
            <div class="object02">
              <div class="form">
                <div class="select">
                  <div class="formSelect" ref="select01" @click="openSelect01">
                    <div class="formSelectList">
                      <input type="text" :value="(status==='') ? '' : (status==='전체') ? '전체' : findStatusName(status)" placeholder="상태" readonly />
                    </div>
                    <div class="formSelectPopup select01">
                      <div class="formSelectPopup-container">
                        <div class="outer">
                          <div class="inner">
                            <div class="formSelectPopup-box">
                              <div class="formSelectPopup-zone" >
                                <div class="formSelectPopup-header">
                                  <input type="text" placeholder="검색어를 입력하세요." />
                                </div>
                                <ul class="formSelectPopup-body">
                                  <li>
                                    <label>
                                      <input type="radio" v-model="selectStatus" value="전체" v-on:change="search_clicked"/>
                                      <input type="checkbox"/>
                                      <i></i>
                                      <span>전체</span>
                                    </label>
                                  </li>
                                  <li>
                                    <label>
                                      <input type="radio" v-model="selectStatus" value="ACTIVE" v-on:change="search_clicked"/>
                                      <input type="checkbox" />
                                      <i></i>
                                      <span>활성화</span>
                                    </label>
                                  </li>
                                  <li>
                                    <label>
                                      <input type="radio" v-model="selectStatus" value="PASSIVE" v-on:change="search_clicked"/>
                                      <input type="checkbox" />
                                      <i></i>
                                      <span>비활성화</span>
                                    </label>
                                  </li>
                                </ul>
                                <div class="formSelectPopup-footer">
                                  <button class="formSelectPopup-cancel">
                                    취소
                                  </button>
                                  <!-- 비활성(Attribute) : disabled -->
                                  <button class="formSelectPopup-confirm">
                                    확인
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="select authority">
                  <div class="formSelect" ref="select02" @click="openSelect02">
                    <div class="formSelectList">
                      <input type="text" :value="(authority==='') ? '' : (authority==='전체') ? '전체' : findRoleName(authority)" placeholder="권한" readonly />
                    </div>
                    <div class="formSelectPopup select02">
                      <div class="formSelectPopup-container">
                        <div class="outer">
                          <div class="inner">
                            <div class="formSelectPopup-box">
                              <div class="formSelectPopup-zone">
                                <div class="formSelectPopup-header">
                                  <input type="text" placeholder="검색어를 입력하세요." />
                                </div>
                                <ul class="formSelectPopup-body">
                                  <li>
                                    <label>
                                      <input type="radio" v-model="selectAuthority" value="전체" v-on:change="search_clicked"/>
                                      <input type="checkbox"/>
                                      <i></i>
                                      <span>전체</span>
                                    </label>
                                  </li>
                                  <li>
                                    <label>
                                      <input type="radio" v-model="selectAuthority" value="AplManager" v-on:change="search_clicked"/>
                                      <input type="checkbox"/>
                                      <i></i>
                                      <span>APL관리자</span>
                                    </label>
                                  </li>
                                  <li>
                                    <label>
                                      <input type="radio" v-model="selectAuthority" value="AplMaster" v-on:change="search_clicked"/>
                                      <input type="checkbox"/>
                                      <i></i>
                                      <span>APL마스터</span>
                                    </label>
                                  </li>
                                  <li>
                                    <label>
                                      <input type="radio" v-model="selectAuthority" value="SktDeveloper" v-on:change="search_clicked"/>
                                      <input type="checkbox"/>
                                      <i></i>
                                      <span>SKT개발자</span>
                                    </label>
                                  </li>
                                  <li>
                                    <label>
                                      <input type="radio" v-model="selectAuthority" value="AplDeveloper" v-on:change="search_clicked"/>
                                      <input type="checkbox"/>
                                      <i></i>
                                      <span>APL개발자</span>
                                    </label>
                                  </li>
                                  <li>
                                    <label>
                                      <input type="radio" v-model="selectAuthority" value="ClubManager" v-on:change="search_clicked"/>
                                      <input type="checkbox"/>
                                      <i></i>
                                      <span>클럽관리자</span>
                                    </label>
                                  </li>
                                </ul>
                                <div class="formSelectPopup-footer">
                                  <button class="formSelectPopup-cancel">
                                    취소
                                  </button>
                                  <!-- 비활성(Attribute) : disabled -->
                                  <button class="formSelectPopup-confirm">
                                    확인
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="input">
                  <input type="text" placeholder="검색어를 입력하세요" v-model="search_word" @keyup.enter="search_clicked"/>
                </div>
                <div class="search" :disabled="((authority==='')&&(status==='')&&(search_word===''))" @click="search_clicked">
                  <button>
                    검색
                  </button>
                </div>
              </div>
            </div>
            <div class="object03">
              <button class="registration" @click="moveMenu('/MA003')">
                등록하기
              </button>
            </div>
          </section>
          <section class="section03 scroll-body">
            <!-- 데이터 없을때(Class) : none -->
            <div class="dev_headerLine" :class="((resTotalNotice.accountCnt === 0) || (accountList1.length === 0)) ? 'object01 none': 'object01'">
              <div class="table thead">
                <!-- 헤더 고정 활성(Class) : active / x축 스크롤 이동 값(Style) : x축 스크롤 이동한 값 만큼 margin-left 마이너스 값 -->
                <div class="fixed grid">
                  <div class="unit">
                    전체 <span>{{accountList1.length > 0 ? accountList1.length : 0}}</span>건
                  </div>
                  <div class="contain">
                    <table class="dev_accountList">
                      <colgroup>
                        <col class="account_id" />
                        <col class="user_name" />
                        <col class="user_phone" />
                        <col class="user_email" />
                        <col class="user_role" />
                        <col class="golfClub" />
                        <col class="status" />
                      </colgroup>
                      <thead>
                      <tr>
                        <!-- 정렬 : sort / 내림차순 : descending / 오름차순 : ascending -->
                        <th class="user_id sort" @click="headerSort('user_id')">
                          <div class="item">
                            아이디
                          </div>
                        </th>
                        <!-- 정렬 : sort / 내림차순 : descending / 오름차순 : ascending -->
                        <th class="user_name sort" @click="headerSort('user_name')">
                          <div class="item">
                            이름
                          </div>
                        </th>
                        <!-- 정렬 : sort / 내림차순 : descending / 오름차순 : ascending -->
                        <th class="user_phone sort" @click="headerSort('user_phone')">
                          <div class="item">
                            휴대폰
                          </div>
                        </th>
                        <!-- 정렬 : sort / 내림차순 : descending / 오름차순 : ascending -->
                        <th class="user_email sort" @click="headerSort('user_email')">
                          <div class="item">
                            이메일
                          </div>
                        </th>
                        <!-- 정렬 : sort / 내림차순 : descending / 오름차순 : ascending -->
                        <th class="user_role sort" @click="headerSort('user_role')">
                          <div class="item">
                            권한
                          </div>
                        </th>
                        <!-- 정렬 : sort / 내림차순 : descending / 오름차순 : ascending -->
                        <th class="clubname sort" @click="headerSort('clubname')">
                          <div class="item">
                            담당골프클럽
                          </div>
                        </th>
                        <!-- 정렬 : sort / 내림차순 : descending / 오름차순 : ascending -->
                        <th class="status sort" @click="headerSort('status')">
                          <div class="item">
                            상태
                          </div>
                        </th>
                      </tr>
                      </thead>
                    </table>
                  </div>
                </div>
              </div>
              <div class="table tbody">
                <div class="contain">
                  <table>
                    <colgroup>
                      <col class="account_id" />
                      <col class="user_name" />
                      <col class="user_phone" />
                      <col class="user_email" />
                      <col class="user_role" />
                      <col class="clubname" />
                      <col class="status" />
                    </colgroup>
                    <tbody>
                    <!-- 비활성화(Class) : disabled -->
                    <tr v-for="accountListInfo in sortedAccountList.slice(0 + (pageNo -1) * pageSize, pageNo * pageSize)" :key="accountListInfo.account_id" @click="moveMenu('/MA002?account_id='+accountListInfo.account_id)" :class="accountListInfo.status === 'PASSIVE' ? 'disabled' : '' ">
                      <td class="account_id">
                        {{ accountListInfo.user_id }}
                      </td>
                      <td class="user_name">
                        {{ accountListInfo.user_name }}
                      </td>
                      <td class="user_phone">
                        {{ accountListInfo.user_phone }}
                      </td>
                      <td class="user_email">
                        {{ accountListInfo.user_email }}
                      </td>
                      <td class="user_role">
                        {{ findRoleName(accountListInfo.user_role) }}
                      </td>
                      <td class="clubname">
                        {{ managingClubsText(accountListInfo) }}
                      </td>
                      <td class="status">
                        {{ (findStatusName(accountListInfo.status) === '비활성화') ? findStatusName(accountListInfo.status) : (findStatusName(accountListInfo.status) === '활성화') ? findStatusName(accountListInfo.status) : accountListInfo.status}}
                      </td>
                    </tr>
                    </tbody>
                    <tbody class="none">
                    <tr>
                      <td colspan="8">
                        데이터가 없습니다.
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
          <section class="section04">
            <div class="object01">
              <!-- 이전 활성 : prevActive / 다음 활성 : nextActive -->
              <div class="paging" :class="pageClass">
                <div class="prev" @click="prevPage">
                  <div class="item">
                    이전
                  </div>
                </div>
                <ul class="number" v-for="index in pageArray" :key="index">
                  <!-- 활성 : active -->
                  <li :class="index == pageNo ? 'active': ''" @click="move_another_page(index)">
                    {{ index }}
                  </li>
                </ul>
                <div class="next" @click="nextPage">
                  <div class="item">
                    다음
                  </div>
                </div>
              </div>
            </div>
            <div class="object02">
              <div class="more" v-if="pageSize < accountList1.length" @click="moreMobileData">
                더보기
              </div>
            </div>
          </section>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div class="alert typeConfirm">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body">
                    답변을 등록하면 문의자에게<br />
                    알림이 발송됩니다.<br />
                    이대로 등록하시겠습니까?
                  </div>
                  <div class="footer">
                    <button class="cancel">
                      취소
                    </button>
                    <button class="confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { aplManagerService, clubInfoService } from '../router'
import FooterLayout from './layout/Footer.vue'
import HeaderLayout from './layout/Header.vue'
import LeftLayout from './layout/Left.vue'
export default {
  name: 'MA001',
  data () {
    return {
      loading: true,
      sortColumn: '',
      sortType: '',
      pageNo: 1,
      pageIndex: 0,
      pageSize: 15,
      pageBuffer: 5,
      accountCnt: 0,
      noticeList: null,
      search_word: '',
      status: '',
      authority: '',
      selectStatus: '',
      selectAuthority: '',
      paramAuthority: '',
      paramStatus: '',
      userId: '',
      userPw: '',
      userName: '',
      userPhone: '',
      userEmail: '',
      userRole: '테스터',
      accountList1: [],
      accountList2: [],
      ccode: 'cc001',
      resTotalNotice: {
        statusCode: null,
        data: {
          accountCnt: 0,
          accountList: []
        }
      },
      statusCodeList: [
        {
          statusCode: 'ACTIVE',
          statusName: '활성화'
        },
        {
          statusCode: 'PASSIVE',
          statusName: '비활성화'
        }
      ],
      userRoleList: [
        {
          roleCode: 'ClubManager',
          roleName: '클럽관리자'
        },
        {
          roleCode: 'AplMaster',
          roleName: 'APL마스터'
        },
        {
          roleCode: 'AplManager',
          roleName: 'APL관리자'
        },
        {
          roleCode: 'AplDeveloper',
          roleName: 'APL개발자'
        },
        {
          roleCode: 'SktDeveloper',
          roleName: 'SKT개발자'
        }
      ],
      clubInfoList: []
    }
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  created: function () {
  },
  beforeMount: function () {
  },
  destroyed: function () {
    window.removeEventListener('resize', this.resizeEvt)
  },
  mounted: function () {
    window.addEventListener('resize', this.resizeEvt)
    clubInfoService.getClubInfoList().then(response => {
      this.clubInfoList = response.data.clubInfoList
      this.search_clicked()
    })
  },
  beforeUpdate: function () {
  },
  updated: function () {
  },
  methods: {
    managingClubsText(clubInfo) {
      const { ccodes = [] } = clubInfo
      const [firstClubCode] = ccodes

      if (!firstClubCode) return '-'

      if (ccodes.length === 1) return this.findClubName(firstClubCode)

      return `${this.findClubName(firstClubCode)} 외 ${ccodes.length - 1}개 클럽`
    },
    moreMobileData: function () {
      this.pageSize = this.pageSize + 15
    },
    findStatusName: function (status) {
      if (this.statusCodeList.find(it => it.statusCode === status) !== undefined) {
        return this.statusCodeList.find(it => it.statusCode === status).statusName
      } else {
        return ''
      }
    },
    findRoleName: function (userRole) {
      if (this.userRoleList.find(it => it.roleCode === userRole) !== undefined) {
        return this.userRoleList.find(it => it.roleCode === userRole).roleName
      } else {
        return ''
      }
    },
    findClubName: function (ccode) {
      if (this.clubInfoList.find(it => it.ccode === ccode) !== undefined) {
        return this.clubInfoList.find(it => it.ccode === ccode).club_name
      } else {
        return ''
      }
    },
    moveMenu: function (path) {
      this.$router.push(path)
    },
    nextPage: function () {
      if (this.pageIndex >= this.pageIndexMax) return
      this.pageIndex++
      this.move_another_page(this.pageArray[0])
    },
    prevPage: function () {
      if (this.pageIndex <= 0) return
      this.pageIndex--
      this.move_another_page(this.pageArray[this.pageArray.length - 1])
    },
    move_another_page: function (index) {
      this.pageNo = index
    },
    search_clicked: function () {
      this.loading = true
      let findClubNameInnerScope = this.findClubName
      // alert(this.search_word)
      this.status = this.selectStatus
      this.authority = this.selectAuthority
      this.paramAuthority = this.authority
      this.paramStatus = this.status
      if (this.paramAuthority === '전체') this.paramAuthority = ''
      if (this.paramStatus === '전체') this.paramStatus = ''
      this.pageNo = 1
      this.pageSize = 15
      this.pageIndex = 0
      aplManagerService.getSummaryManagementUserListView(this.orderTarget, this.orderValue, this.paramStatus, this.paramAuthority, this.search_word).then(response => {
        this.resTotalNotice = response.data
        this.resTotalNotice.accountList.forEach(function (item) {
          item.clubname = findClubNameInnerScope(item.ccode)
        })
        this.accountList1 = this.resTotalNotice.accountList
        this.accountCnt = this.resTotalNotice.accountCnt
        console.log(this.resTotalNotice.accountList)
      }).catch(error => {
        console.log('getTotalNotice.err.===>', error)
      })
    },
    headerSort: function (target) {
      if (document.querySelector('.dev_accountList thead tr th.ascending') !== null) {
        document.querySelector('.dev_accountList thead tr th.ascending').classList.remove('ascending')
      }
      if (document.querySelector('.dev_accountList thead tr th.descending') !== null) {
        document.querySelector('.dev_accountList thead tr th.descending').classList.remove('descending')
      }
      if (this.sortColumn === target) {
        if (this.sortType === 'asc') {
          this.sortType = 'desc'
          document.querySelector('.dev_accountList thead tr th.' + target).classList.add('descending')
        } else {
          this.sortType = 'asc'
          document.querySelector('.dev_accountList thead tr th.' + target).classList.add('ascending')
        }
      } else {
        document.querySelector('.dev_accountList thead tr th.' + target).classList.add('ascending')
        this.sortColumn = target
        this.sortType = 'asc'
      }
    },
    resizeEvt: function () {
      if (this.mobileFlag) {
        if (window.innerWidth > 1279) {
          this.mobileFlag = false
          this.search_clicked()
        }
      } else {
        if (window.innerWidth < 1280) {
          this.mobileFlag = true
          this.selectStatus = ''
          this.selectAuthority = ''
          this.status = ''
          this.authority = ''
          this.search_word = ''
          this.search_clicked()
          this.pageNo = 1
          this.pageIndex = 0
          this.pageSize = 15
        }
      }
    }
  },
  computed: {
    sortedAccountList: function () {
      let _accountList = [...this.accountList1]
      if (this.sortType === 'desc') {
        return _accountList.sort(this.descSort)
      } else if (this.sortType === 'asc') {
        return _accountList.sort(this.ascSort)
      } else {
        return _accountList.sort(this.ascSort)
      }
    },
    pageArray: function () {
      if (this.accountCnt <= 0) return [1]
      let pageMax = Math.floor((this.accountCnt - 1) / this.pageSize) + 1
      let arr = []
      for (let i = 1; i <= this.pageBuffer; i++) {
        let j = this.pageIndex * this.pageBuffer + i
        if (j > pageMax) break
        arr.push(j)
      }
      return arr
    },
    pageIndexMax: function () {
      return Math.floor((this.accountCnt - 1) / (this.pageSize * this.pageBuffer))
    },
    pageClass: function () {
      return {
        nextActive: this.pageIndex < this.pageIndexMax,
        prevActive: this.pageIndex > 0
      }
    }
  },
  watch: {
    pageIndex: function (val) {
      this.pageIndex = val < 0 ? 0 : val > this.pageIndexMax ? this.pageIndexMax : val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MA001.vue